module.exports = __webpack_public_path__ + "img/slide_item_2.b224c2c3.png";